import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-tuichu1",
  "use": "icon-icon-tuichu1-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-tuichu1\"><path d=\"M554.6496 128H469.3504v426.6496h85.2992V128z m206.08 92.5696l-60.5696 60.6208A295.2704 295.2704 0 0 1 810.6496 512 298.496 298.496 0 0 1 512 810.6496a298.496 298.496 0 0 1-188.5696-529.92L263.2704 220.5696A381.1328 381.1328 0 0 0 128 512a384 384 0 0 0 768 0 381.1328 381.1328 0 0 0-135.2704-291.4304z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/icon-tuichu1.svg
// module id = cwFZ
// module chunks = 3